import { Route } from '@angular/router';
import { ContentEditorListComponent } from 'src/app/pages/media/content-editor-list/content-editor-list.component';
import { ContentEditorComponent } from 'src/app/pages/media/content-editor/content-editor.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { ContentCreatorComponent } from 'src/app/pages/media/content-creator/content-creator.component';

export const contentEditor: Route = {
  path: 'content-editor',
  title: 'nav.contentEditor',
  data: {
    breadcrumb: 'nav.contentEditor',
    icon: SbIcons.playEdit,
  },

  children: [
    {
      path: '',
      component: ContentEditorListComponent,
      data: {
        id: RoutingID.contentEditor,
        breadcrumb: '',
      },
    },
    {
      path: 'content-editor-edit/:contentEditorID',
      title: 'nav.contentEditor.templates.edit',
      data: {
        breadcrumb: 'nav.contentEditor.templates.edit',
        icon: SbIcons.edit,
        id: RoutingID.contentEditorEdit,
      },
      children: [
        {
          path: '',
          component: ContentEditorComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'content-editor-create-content/:contentEditorID',
      title: 'nav.contentEditor.createContentFromTemplate',
      data: {
        breadcrumb: 'nav.contentEditor.createContentFromTemplate',
        icon: SbIcons.plus,
        id: RoutingID.contentEditorCreateContent,
      },
      children: [
        {
          path: '',
          component: ContentCreatorComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'content-editor-edit-content/:mediumID',
      title: 'lang.globals.editMedium',
      data: {
        breadcrumb: 'lang.globals.editMedium',
        icon: SbIcons.edit,
        id: RoutingID.contentEditorEditContent,
      },
      children: [
        {
          path: '',
          component: ContentCreatorComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'content-editor-create',
      title: 'nav.contentEditor.templates.create',
      data: {
        breadcrumb: 'nav.contentEditor.templates.create',
        icon: SbIcons.plus,
        id: RoutingID.contentEditorCreate,
      },
      children: [
        {
          path: '',
          component: ContentEditorComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
